import { RouteConfig } from 'config/constants/route'
import { useRouter } from 'next/router'
import { createContext, useCallback, useEffect, useMemo, useRef } from 'react'

const ROOT_URL = RouteConfig.Home
const useHistoryUrl = (rootUrl: string = ROOT_URL) => {
  const router = useRouter()
  const historyRef = useRef<string[]>([])

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      const history = historyRef.current
      if (history.length === 0 || history[history.length - 1] !== url) {
        history.push(url)
      }
    }

    handleRouteChange(router.asPath)

    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])

  const goBack = useCallback(() => {
    const history = historyRef.current
    // remove current url
    if (history.length > 0) {
      history.pop()
    }
    const backUrl = history.length > 0 ? history[history.length - 1] : rootUrl

    router.push(backUrl)
  }, [router, rootUrl])

  return { goBack }
}

export const UrlHistoryContext = createContext<{ goBack: () => void } | undefined>(undefined)

export const HistoryProvider = ({ children }: { children: React.ReactNode }) => {
  const { goBack } = useHistoryUrl()
  const value = useMemo(() => ({ goBack }), [goBack])
  return <UrlHistoryContext.Provider value={value}>{children}</UrlHistoryContext.Provider>
}
